import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import styles from "./Grid.scss";

// eslint-disable-next-line tree-shaking/no-side-effects-in-initialization
const Row = forwardRef(({ children, gutter, customClass, ...others }, ref) => {
  const classes = cx(styles.row, customClass, {
    [styles["row--gutter"]]: gutter,
  });
  return (
    <div className={classes} ref={ref} {...others}>
      {children}
    </div>
  );
});

Row.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  gutter: PropTypes.bool,
  customClass: PropTypes.string,
};

Row.defaultProps = {
  gutter: false,
  customClass: undefined,
};

Row.displayName = "Grid.Row";

export default Row;
